import { render, staticRenderFns } from "./AIOPENIndex.vue?vue&type=template&id=0922a688&scoped=true&"
import script from "./AIOPENIndex.vue?vue&type=script&lang=js&"
export * from "./AIOPENIndex.vue?vue&type=script&lang=js&"
import style0 from "./AIOPENIndex.vue?vue&type=style&index=0&id=0922a688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922a688",
  null
  
)

export default component.exports